import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";
import IsValidName from "../../../../utils/validators/IsValidName";
import Loading from "../../../home/components/Loading";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import FormActions from "../../components/FormActions";
import { InputField } from "../../components/InputField";
import { useParams } from "react-router-dom";
import { Box, Button } from "@material-ui/core";
import { VoiceModelsFormModal } from "./components/VoiceModelsFormModal";
import { modalKindOptionsEnum } from "./ModalKindOptionsEnum";
import store from "../../../../store/store";
import roles from "../../../../enums/RoleEnum";
import MetricsContainer from "./MetricsContainer";
import { modelApiHelper } from "./ModelApiService";
import VITSFields from "./components/VITSFields";
import ElevenLabsFields from "./components/ElevenLabsFields";
import XTTSFields from "./components/XTTSFields";

export default function VoiceModelsForm(props) {
	const api = new MutantApiService();
	const { auth } = store.getState();
	const [isLoading, setIsLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [modalKind, setModalKind] = useState("delete");

	const [voiceModel, setVoiceModel] = useState();
	const [voiceConfig, setVoiceConfig] = useState();
	const initialState = {
		name: "",
		description: "",
		status: false,
		location: "models/vits",
		updatedAt: "",
		provider: "",
		voiceId: "",
		stability: "",
		similarityBoost: "",
		style: "",
		speed: ""
	};
	const handleModalKind = kind => {
		setModalKind(kind);
		setShowModal(true);
	};
	const [state, setState] = useState(initialState);

	const handleChange = e => {
		const { name, value } = e.target;
		setState(prevState => ({ ...prevState, [name]: value }));
	};


	const [fileInputFilled, setFileInputFilled] = useState(false);

	const [file, setFile] = useState();
	const [streamingMetrics, setStreamingMetrics] = useState();

	const [resetInput, setResetInput] = useState();
	const [providerOptions, setProviderOptions] = useState([]);

	useEffect(() => {
		if (!!resetInput) {
			setVoiceModel("");
			setVoiceConfig("");
			setFile("");
			setState(initialState);
			setResetInput(false);
		}
	}, [resetInput, initialState]);
	const { id } = useParams();

	useEffect(() => {
		const fetchProviders = async () => {
			try {
				const response = await api.makeHttpRequest({
					url: "/provider?status=active",
				});
				const providers = (response.data ?? []).map(provider => ({
					value: provider.name,
					label: provider.name
				}));
				setProviderOptions(providers);
			} catch (error) {
				console.error("Error fetching providers:", error);
				Swal.fire(
					"Erro!",
					"Erro ao buscar providers. Tente novamente mais tarde.",
					"error"
				);
			}
		};
		fetchProviders();
	}, []);


	const createTableRows = data => {
		return Object.entries(data).map(([key, value], index) => {
			return (
				<tr key={index}>
					<td>{key}</td>
					<td>{JSON.stringify(value)}</td>
				</tr>
			);
		});
	};

	useEffect(() => {
		if (id) {
			const fetchModel = async () => {
				try {
					const model = await modelApiHelper.fetchModelById(id);
					const provider = model.provider || "";
					const providerCfg = model.providerConfig || {};

					setState(prevState => ({
						...prevState,
						name: model.name || "",
						description: model.description || "",
						status: !!model.status,
						location: providerCfg?.location || "",
						updatedAt: model.updatedAt || model.updated_at || "",
						provider: provider,
						voiceId: providerCfg?.voiceId ?? "",
						stability: providerCfg?.stability ?? "",
						similarityBoost: providerCfg?.similarityBoost ?? "",
						style: providerCfg?.style ?? "",
						speed: providerCfg?.speed ?? ""
					}));

					if (provider === "XTTS") {
						const samplePath = providerCfg?.voiceSamplePath;
						if (samplePath) {
							setFile(samplePath);
							setFileInputFilled(true);
						}
					}

					if (provider === "VITS") {
						const hasAny = !!(providerCfg?.voiceModelPath || providerCfg?.voiceConfigPath || providerCfg?.location);
						if (hasAny) {
							setFileInputFilled(true);
						}
					}
				} catch (error) {
					Swal.fire(
						"Erro!",
						error || "Erro ao recuperar Modelos, tente novamente mais tarde.",
						"error"
					);
				}
			};
			fetchModel(); 
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	/**
	 * Submits voice model form data to the API
	 * 
	 * EXPECTED PAYLOAD FORMAT (standardized for both POST and PATCH):
	 * FormData {
	 *   name: "model_name" (lowercase)
	 *   provider: "ELEVEN_LABS" | "VITS" | "XTTS"
	 *   description: "optional description"
	 *   providerConfig: JSON string
	 *     For ELEVEN_LABS: {"voiceId": "...", "stability": 0.5, "similarityBoost": 0.75, "style": "...", "speed": 1.0}
	 *     For VITS: {} (empty, files sent separately)
	 *     For XTTS: {} (empty, files sent separately)
	 *   voice_config: File (VITS only)
	 *   voice_model: File (VITS only)
	 *   voice_sample: File (XTTS only)
	 * }
	 * 
	 * IMPORTANT: providerConfig must NOT be wrapped with provider name
	 * ❌ WRONG: { "ELEVEN_LABS": { "voiceId": "..." } }
	 * ✅ CORRECT: { "voiceId": "..." }
	 */
	const submit = async e => {
		e.preventDefault();
		setIsLoading(true);

		try {
			const formData = new FormData();
			formData.append("name", state.name.toLowerCase());
			formData.append("provider", state.provider);
			formData.append("description", state.description || "");

			const providerConfig = {};

		if (state.provider === "VITS") {
			if (voiceConfig) {
				const tmpVoiceConfig = new File([
					voiceConfig
				], `tmp_${voiceConfig.name}`);
				const tmpVoiceModel = new File([voiceModel], `tmp_${voiceModel.name}`);
				formData.append("voice_config", tmpVoiceConfig);
				formData.append("voice_model", tmpVoiceModel);
			}
			} else if (state.provider === "ELEVEN_LABS") {
				providerConfig.voiceId = state.voiceId;
				providerConfig.stability = state.stability !== "" ? parseFloat(state.stability) : undefined;
				providerConfig.similarityBoost = state.similarityBoost !== "" ? parseFloat(state.similarityBoost) : undefined;
				providerConfig.style = state.style;
				providerConfig.speed = state.speed !== "" ? parseFloat(state.speed) : undefined;
			} else if (state.provider === "XTTS") {
				if (voiceModel) {
					formData.append("voice_sample", voiceModel);
				}
			}

			// Log the payload being sent for debugging
			const providerConfigString = JSON.stringify(providerConfig);
			console.log(`[VoiceModelsForm] Submitting ${id ? "UPDATE (PATCH)" : "CREATE (POST)"}`);
			console.log(`[VoiceModelsForm] Provider: ${state.provider}`);
			console.log(`[VoiceModelsForm] providerConfig payload:`, providerConfig);
			console.log(`[VoiceModelsForm] providerConfig JSON string:`, providerConfigString);

			formData.append("providerConfig", providerConfigString);
			await modelApiHelper.saveModel(id, formData);
			setIsLoading(false);
			afterSubmit();
		} catch (e) {
			let message = "";
			if (e?.response?.data?.messages && e.response.data.messages.length > 0) {
				message = e.response.data.messages[0];
			} else if (e?.response?.data?.message) {
				message = e.response.data.message;
			}
			
			setIsLoading(false);
			Swal.fire(
				"Erro!",
				message && message.trim().length > 0
					? message
					: "Erro ao enviar o formulário, tente novamente mais tarde.",
				"error"
			);
		}
	};

	const afterSubmit = async () => {
		setResetInput(true);

		await Swal.fire({
			title: "Sucesso!",
			text: "Dados salvos com sucesso.",
			icon: "success",
			showCancelButton: false,
			confirmButtonText: "Ok"
		});

		window.location.replace("/dashboard/models");
	};

	const formIsValid = useCallback(() => {
		const isNameValid = state.name && state.name.length > 2;
		const provider = state.provider;

		if (!provider) return false;

		if (!id) {
			if (provider === "VITS") {
				return isNameValid && !!(voiceModel && voiceConfig);
			}
			if (provider === "ELEVEN_LABS") {
				const hasElevenFields =
					state.voiceId &&
					(state.stability !== undefined && state.stability !== "") &&
					(state.similarityBoost !== undefined && state.similarityBoost !== "") &&
					state.style &&
					(state.speed !== undefined && state.speed !== "");
				return isNameValid && !!hasElevenFields;
			}
			if (provider === "XTTS") {
				return isNameValid && !!fileInputFilled;
			}
			return false;
		}

		if (provider === "VITS") {
			return isNameValid && ((!voiceModel && !voiceConfig) || (voiceModel && voiceConfig));
		}
		if (provider === "ELEVEN_LABS") {
			const hasElevenFields =
				state.voiceId &&
				(state.stability !== undefined && state.stability !== "") &&
				(state.similarityBoost !== undefined && state.similarityBoost !== "") &&
				state.style &&
				(state.speed !== undefined && state.speed !== "");
			return isNameValid && !!hasElevenFields;
		}
		if (provider === "XTTS") {
			return isNameValid;
		}
		return false;
	}, [state, id, voiceModel, voiceConfig, fileInputFilled]);

	const onCleanForm = async () => {
		setResetInput(true);
		setVoiceModel("");
		setVoiceConfig("");
		setFile("");
		setState(initialState);
	};

	const renderProviderSpecificFields = () => {
		if (!state.provider) {
			return null; 
		}

		if (state.provider === "VITS") {
			return (
				<VITSFields
					setVoiceConfig={setVoiceConfig}
					setVoiceModel={setVoiceModel}
					setFileInputFilled={setFileInputFilled}
					fileInputFilled={fileInputFilled}
					id={id}
				/>
			);
		} else if (state.provider === "ELEVEN_LABS") {
			return <ElevenLabsFields state={state} handleChange={handleChange} />;
		} else if (state.provider === "XTTS") {
			return <XTTSFields file={file} setFileInputFilled={setFileInputFilled} setVoiceModel={setVoiceModel} />;
		}
		return null;
	};

	window.setPageTitle("Gerenciamento de Modelos - Admin");

	const isEditing = !!id;

	const handleProviderChange = e => {
		const { value } = e.target;
		setState({
			...initialState,
			provider: value,
			location: value === "VITS" ? "models/vits" : ""
		});
		setVoiceModel(null);
		setVoiceConfig(null);
		setFile(null);
		setFileInputFilled(false);
	};

	return (
		<>
			<Loading isLoading={isLoading} />
			<AdminTitle disableHeader title={id ? "Atualizar Voz" : "Nova Voz"} />
			<VoiceModelsFormModal
				showModal={showModal}
				setShowModal={setShowModal}
				kind={modalKind}
				id={id}
				name={state.name}
			/>
			<Card className="mt-4">
				<StyledCardBody
					style={{
						display: "block"
					}}
				>
					<Form style={{ flex: "1" }}>
						{/* row 1 */}
						<Form.Row>
							{/* Provider */}
							<Form.Group as={Col} lg="6" xs="12">
								<Form.Label>Provider *</Form.Label>
								<Form.Control
									as="select"
									name="provider"
									value={state.provider}
									onChange={handleProviderChange}
									required
									disabled={isEditing}
								>
									<option value="">Selecione um provider</option>
									{providerOptions.map(option => (
										<option key={option.value} value={option.value}>
											{option.label}
										</option>
									))}
								</Form.Control>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							{/* Nome */}
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="text"
									name="name"
									label="Nome"
									placeholder="Digite o nome"
									value={state.name}
									onChange={handleChange}
									isInvalid={state.name && !IsValidName(state.name)}
									required
								/>
							</Form.Group>
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="text"
									name="status"
									label="Status"
									value={!!state.status ? "Ativo" : "Inativo"}
									disabled={true}
								/>
							</Form.Group>
						</Form.Row>

						{renderProviderSpecificFields()}
					</Form>
					<Box
						style={{
							width: "100%",
							justifyContent: "center",
							alignItems: "center",
							marginTop: "30px",
							display: id ? "flex" : "none"
						}}
					>
						<Button
							variant="contained"
							style={{
								backgroundColor: "#a7281f",
								color: "#fff",
								display: auth.user.role === roles.ADMIN ? "block" : "none"
							}}
							onClick={() => handleModalKind(modalKindOptionsEnum.delete)}
						>
							Excluir
						</Button>
						<Button
							variant="contained"
							style={{
								backgroundColor: "#e09a19",
								color: "#fff",
								marginLeft: "20px",
								display:
									auth.user.role === roles.ADMIN ||
									auth.user.role === roles.MANAGER
										? "block"
										: "none"
							}}
							onClick={() =>
								handleModalKind(
									state.status
										? modalKindOptionsEnum.deactivate
										: modalKindOptionsEnum.activate
								)
							}
						>
							{id && (state.status ? "Desativar" : "Ativar")}
						</Button>
					</Box>
					<Box
						style={{
							width: "100%",
							justifyContent: "start",
							alignItems: "start",
							marginTop: "30px",
							display: auth.user.role === roles.ADMIN ? "flex" : "none"
						}}
					>
						<MetricsContainer />
					</Box>
				</StyledCardBody>
			</Card>
			<FormActions
				module="models"
				formIsValid={formIsValid()}
				onCleanForm={onCleanForm}
				onSubmit={submit}
				hideReload
			/>
		</>
	);
}
